/** "Waiting for Rep Two's outcome"; "Waiting for the rep's outcome" when nobody is named (ACL-486).
 *  A module of its own with no imports: `lib/contacts` and `lib/cadence` both say it, and neither
 *  has to import the other for it. */
export function waitingFor(rep: string | null | undefined): string {
  return `Waiting for ${rep ? `${rep}'s` : "the rep's"} outcome`;
}
